import React from 'react';
import pix from '../../images/pix.gif';
import email from '../email';

export default class NotFoundPage extends React.Component {
  render() {
    return (
      <main>
        <div className="content">
          <div className="column leftWindow">
            <div className="twoColumnsWrapper">
              <div className="errorMessage" id="errorMessage">
                <img className="errorMessageIcon" alt={email.optin.ui.header.jpmorgan.logo.eng} src={pix} />
                <div className="pageHeader">
                  <div className="centerWrap">
                    <h1>Page Not Found</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    );
  }
}
